import React, { useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet,Image } from '@react-pdf/renderer';
import { useSelector } from 'react-redux';
import { formatDate } from '../../constants/DateFormatter';
// import user1 from "../../assets/images/users/student.jpg";
//import logo from "../../assets/images/logos/schoolLogo.png";

const styles = StyleSheet.create({
  page: { padding: 20 },
  header: { textAlign: 'center', fontSize: 22, fontWeight: 'bold', marginBottom: 10, color: "green",fontStyle:"italic" },
  header2: { textAlign: 'center', fontSize: 12, marginTop: 15, marginBottom: 5, color: "red" },
  headerContent: { textAlign: 'center', fontSize: 8, marginBottom: 5, color: "grey" },
  subHeader: { textAlign: 'center', fontSize: 14, marginBottom: 15, color: "blue", fontWeight: 'bold', textDecoration: "underline" },
  section: { marginBottom: 10, borderBottom: '1 solid black', paddingBottom: 5 },

  table: { display: "flex", flexDirection: "column", width: "100%" },
  row: { flexDirection: "row", justifyContent: "space-between", marginBottom: 5,paddingBottom: 5 },
  label: { fontSize: 12, width: "50%", textAlign: "left" },
  value: { fontSize: 12, width: "50%", textAlign: "left", fontWeight: 'extrabold' },
  headerContainer: { 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center',
    marginBottom: 10
  },
  logo: { width: 60, height: 60 }, // Adjust the logo size
  studentPhoto: { width: 60, height: 80, borderRadius: 5 }, // Adjust student photo size
  school_name: { textAlign: 'center', fontSize: 28, fontWeight: 'bold', color: "green", flex: 1,marginBottom: 10 },
  centerContent: { 
    flex: 1,  // Allows the content to take equal space between images
    alignItems: 'center', // Ensures text aligns at the center
    justifyContent: 'center', // Ensures content is vertically aligned
  },

});



const AdmissionFormPDF = ({ data,systemData,siblingsData,session }) => {
  const toBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
  
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  
  // Usage
  const base64Image = async() => {
    await toBase64(process.env.REACT_APP_API_BASE_URL + data.stud_img_path)
  };
 
return(
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Top Section with Logo & Student Image */}
      <View style={styles.headerContainer}>
        <Image src={"/assets/logos/" + systemData.school_logo} style={styles.logo} />
        <View style={styles.centerContent}>
        <Text style={styles.school_name}>{systemData.school_name}</Text>
        
      <Text style={styles.header2}>{systemData.school_type}</Text>
      <Text style={styles.headerContent}>{systemData.address}</Text>
      <Text style={styles.headerContent}>{systemData.school_phn}</Text>
        </View>
        <Image src={{ uri: process.env.REACT_APP_API_BASE_URL + data.stud_img_path, method: "GET", headers: { "Cache-Control": "no-cache" }, body: "" }} style={styles.studentPhoto} />
        {/* <Image src={base64Image} style={styles.studentPhoto} /> */}
        {/* <Image src="http://localhost:6203/Admission_Master/Student_Images/20250316201122529.jpg" style={styles.studentPhoto} /> */}
        
      </View>

 {/* ID & Session */}
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', fontSize: 10 }}>
        <Text>I.D. No. : {systemData.school_code}</Text>
        <Text>Session : {session}</Text>
      </View>

      <View style={{ border: "1 solid black", borderRadius: "10px", padding: 5 }}>
        {/* Student Details */}
        <View style={styles.section}>
          <Text style={styles.subHeader}>ADMISSION FORM</Text>

          <View style={styles.row}>
          <Text style={styles.label}>ADMISSION NO:</Text>
          <Text style={styles.value}>{data.admit_no}</Text>
            <Text style={styles.label}>AADHAR NO:</Text>
            <Text style={styles.value}>{data.addhar_no}</Text>          
          </View>
          <View style={styles.row}>
          <Text style={styles.label}>PEN ID:</Text>
          <Text style={styles.value}>{data.pen_id}</Text>
            <Text style={styles.label}>APAAR ID:</Text>
            <Text style={styles.value}>{data.apaar_id}</Text>          
          </View>
          <View style={styles.row}>
            <Text style={[styles.label]}>IN WHICH CLASS ADMISSION IS REQUIRED:</Text>
            <Text style={styles.value}>{data.curr_class}</Text>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.subHeader}>ABOUT THE CHILD</Text>
          <View style={styles.table}>
            <View style={styles.row}>
              <Text style={styles.label}>NAME:</Text>
              <Text style={styles.value}>{data.stud_name}</Text>

              <Text style={styles.label}></Text>
              <Text style={styles.value}></Text>
            </View>

            <View style={styles.row}>

              <Text style={styles.label}>DATE OF BIRTH:</Text>
              <Text style={styles.value}>{formatDate(data.d_o_b)}</Text>
              <Text style={styles.label}>GENDER:</Text>
              <Text style={styles.value}>{data.sex_mf}</Text>
            </View>
            <View style={styles.row}>

              <Text style={styles.label}>CASTE:</Text>
              <Text style={styles.value}>{data.category_class}</Text>
              <Text style={styles.label}>RELIGION:</Text>
              <Text style={styles.value}>{data.religion_name}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>NATIONALITY:</Text>
              <Text style={styles.value}>INDIAN</Text>
              <Text style={styles.label}>MOTHER TONGUE:</Text>
              <Text style={styles.value}>{data.mother_tong}</Text>
            </View>
            
            <View style={styles.row}>
              <Text style={[styles.label,{width: "100%"}]}>ADDRESS: {data.sadd1}, {data.sadd2}, {data.sadd3}</Text>
            </View>
          </View>

        </View>

        {/* Parent Details */}
        <View style={styles.section}>
          <Text style={styles.subHeader}>ABOUT THE PARENTS</Text>
          <View style={styles.row}>
            <Text style={styles.label}></Text>
            <Text style={styles.value}>FATHER</Text>
            <Text style={styles.value}>MOTHER</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>NAME:</Text>
            <Text style={styles.value}>{data.f_name}</Text>
            <Text style={styles.value}>{data.m_name}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>QUALIFICATION:</Text>
            <Text style={styles.value}>{data.f_quali}</Text>
            <Text style={styles.value}>{data.m_quali}</Text>
          </View>
                    
          <View style={styles.row}>
            <Text style={styles.label}>PROFESSION:</Text>
            <Text style={styles.value}>{data.f_prof}</Text>
            <Text style={styles.value}>{data.m_prof}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>INCOME:</Text>
            <Text style={styles.value}>{data.f_income}</Text>
            <Text style={styles.value}>{data.m_income}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>MOBILE:</Text>
            <Text style={styles.value}>{data.f_mob}</Text>
            <Text style={styles.value}>{data.m_mob}</Text>
          </View>
          
          <View style={styles.row}>
            <Text style={styles.label}>AADHAR NO.:</Text>
            <Text style={styles.value}>{data.f_adhaar_no}</Text>
            <Text style={styles.value}>{data.m_adhaar_no}</Text>
          </View>
        </View>

        {/* Siblings Details */}
        <View style={styles.section}>
          <Text style={styles.subHeader}>ABOUT BROTHERS-SISTERS STUDYING IN SCHOOL</Text>
          {siblingsData.length ? siblingsData.map((sibling, index) => ( 
          <View key={index} style={styles.row}>
            {/* <Text style={styles.label}></Text> */}
            <Text style={styles.value}>{index+1}.  ADM No. : {sibling.adm_no}</Text>
            <Text style={styles.value}>NAME: {sibling.sibling_Name}</Text>
            {/* <Text style={styles.value}></Text> */}
            
            {/* <Text style={styles.label}></Text> */}
            <Text style={styles.value}>CLASS : {sibling.sibling_class}</Text>
          </View>
           )):(
            <View style={styles.row}>
            <Text style={[styles.value,{textAlign:"center",width: "100%"}]}>NO BROTHER/SISTER STUDYING IN THE SCHOOL</Text>
          </View>
           )
           } 
        </View>


        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={{ float: "left", fontSize: 10, marginTop: 30 }}>Date : - {formatDate(data.adm_date)}</Text>
            <Text style={{ float: "right", fontSize: 10, marginTop: 30 }}>Signature</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.value}></Text>
            <Text style={{ float: "right", fontSize: 10, marginTop: 5 }}>(Father/Mother/Guardian)</Text>
          </View>
          {/* <Text style={styles.header}>{systemData.school_name}</Text> */}

        </View>


      </View>

    </Page>
  </Document>
);
}
export default AdmissionFormPDF;
